import React from 'react';
import Modal from '../modal';
// @ts-ignore
import { Router } from '../../configs/routes';

interface Props {
  onDismiss: () => void;
}

const KycIncompleteModal: React.FC<Props> = ({ onDismiss }) => {
  const handleCompleteKyc = () => {
    Router.pushRoute('/save/complete-kyc');
  };

  return (
    <Modal
      title="Complete Your KYC"
      maxWidth="500px"
      onDismiss={onDismiss}
      hideHeader={true}
    >
      <div className="lil-p-6 lil-text-center">
        <div className="lil-mb-6">
          <img
            src="https://assets.clear.in/clearsave/images/1766325708_group1814217977.svg"
            alt="KYC Required"
            className="lil-mx-auto lil-mb-4"
            width="80"
            height="80"
          />
        </div>
        <h3
          className="lil-mb-4 lil-font-bold lil-text-gray-900"
          style={{ fontSize: '20px' }}
        >
          Complete your KYC
        </h3>
        <p
          className="lil-mb-6 lil-text-gray-600 lil-leading-relaxed"
          style={{ fontSize: '14px' }}
        >
          Please submit your KYC documents to start investing. This is a
          one-time process required by{' '}
          <span className="lil-font-bold">SEBI regulations</span>.
        </p>
        <div
          className="lil-mb-6 lil-text-left lil-p-4 lil-rounded-lg"
          style={{ backgroundColor: '#EEF5FF' }}
        >
          <p
            className="lil-font-semibold lil-mb-3"
            style={{ fontSize: '14px', color: 'black' }}
          >
            Documents Required
          </p>
          <ul
            className="lil-list-none lil-space-y-2 lil-text-gray-700"
            style={{ fontSize: '14px' }}
          >
            <li className="lil-flex lil-items-start">
              <span className="lil-mr-2">•</span>
              <span>PAN Card</span>
            </li>
            <li className="lil-flex lil-items-start">
              <span className="lil-mr-2">•</span>
              <span>Address Proof (Aadhaar/Passport/Voter ID)</span>
            </li>
            <li className="lil-flex lil-items-start">
              <span className="lil-mr-2">•</span>
              <span>Bank Account Details</span>
            </li>
          </ul>
        </div>
        <p className="lil-mb-6 lil-text-gray-500" style={{ fontSize: '14px' }}>
          For queries, contact{' '}
          <a
            href="mailto:invest@cleartax.in"
            className="lil-underline"
            style={{ color: '#155DFC' }}
          >
            invest@cleartax.in
          </a>
        </p>
        <div
          className="lil-flex lil-flex-row lil-justify-around lil-items-center lil-py-4 lil-px-10 lil-rounded-lg lil-mb-2 lil-flex-wrap lil-gap-3"
          style={{ backgroundColor: '#EEF5FF' }}
        >
          <img
            src="https://assets.clear.in/clearsave/images/1766325846_aicpasoc2whtie.svg"
            alt="SOC 2"
            className="lil-h-8 lil-w-auto"
          />
          <img
            src="https://assets.clear.in/clearsave/images/1766325992_vector.svg"
            alt="Security"
            className="lil-h-8 lil-w-auto"
          />
          <img
            src="https://assets.clear.in/clearsave/images/1766326075_iso27001informationsecurity1.svg"
            alt="ISO 27001"
            className="lil-h-8 lil-w-auto"
          />
          <img
            src="https://assets.clear.in/clearsave/images/1766325846_aicpasoc2whtie.svg"
            alt="SOC 2"
            className="lil-h-8 lil-w-auto"
          />
          <img
            src="https://assets.clear.in/clearsave/images/1766325908_icons_clear011.svg"
            alt="Clear"
            className="lil-h-8 lil-w-auto"
          />
        </div>
        <button
          className="lil-btn lil-btn-blue lil-w-full lil-mb-3"
          onClick={handleCompleteKyc}
        >
          Submit KYC Document
        </button>
        <button
          className="lil-btn lil-btn-outline lil-w-full"
          onClick={onDismiss}
        >
          Maybe Later
        </button>
      </div>
    </Modal>
  );
};

export default KycIncompleteModal;



// WEBPACK FOOTER //
// ./components/kyc/KycIncompleteModal.tsx